import { ExternalLink as ExternalLinkIcon } from "lucide-react";
import type { ComponentProps } from "react";
import { useTranslations } from "use-intl";

import { cn } from "@lawline/ui/core/cn";

// A link that opens another site in a new tab, with a cue for sighted and screen-reader users.
// The default style is an inline text link. A caller that passes className, such as a Button with
// asChild, styles it fully. cueClassName lets the icon fade with a sidebar label.
export function ExternalLink({
	children,
	className = "text-foreground underline underline-offset-2",
	cueClassName,
	...props
}: ComponentProps<"a"> & { cueClassName?: string }) {
	const t = useTranslations("common.links");
	return (
		<a {...props} className={className} target="_blank" rel="noopener noreferrer">
			{children}
			<ExternalLinkIcon
				aria-hidden
				className={cn("ml-0.5 inline-block size-3 align-baseline", cueClassName)}
			/>
			<span className="sr-only">{` (${t("newTab")})`}</span>
		</a>
	);
}
